import React from 'react';
import './assets/styles/index.scss';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import TopStory from './pages/TopStories/TopStory';
import DetailStory from './components/DetailStory/DetailStory';
import MoreTopStory from './pages/TopStories/MoreTopStory';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import NewestStory from './pages/NewestStories/NewestStory';
import MoreNewestStory from './pages/NewestStories/MoreNewestStory';
import AskStory from './pages/AskStories/AskStory';
import MoreAskStory from './pages/AskStories/MoreAskStory';
import ShowStory from './pages/ShowStories/ShowStory';
import MoreShowStory from './pages/ShowStories/MoreShowStory';
import JobStory from './pages/JobStories/JobStory';
import MoreJobStory from './pages/JobStories/MoreJobStory';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/jobs/page/:page" component={MoreJobStory} exact />
        <Route path="/jobs" component={JobStory} exact />
        <Route path="/show/page/:page" component={MoreShowStory} exact />
        <Route path="/show" component={ShowStory} exact />
        <Route path="/ask/page/:page" component={MoreAskStory} exact />
        <Route path="/ask" component={AskStory} exact />
        <Route path="/newest/page/:page" component={MoreNewestStory} exact />
        <Route path="/newest" component={NewestStory} exact />
        <Route path="/item/:type/:id" component={DetailStory} exact />
        <Route path="/page/:page" component={MoreTopStory} exact />
        <Route path="/" component={TopStory} exact />
      </Switch>
    </Router>
  );
};

export default App;
